import PaymentMethodsApi from '@/services/shop/PaymentMethodsApi'
import {
  PaymentMethodCode,
  PaymentMethodInterface,
} from '@/models/shop/PaymentMethod.types'

export { PaymentMethodCode }
export type { PaymentMethodInterface }

export class PaymentMethodDTO implements PaymentMethodInterface {
  id = ''
  name = ''
  l10n_name_key = ''
  code: PaymentMethodCode = PaymentMethodCode.CSH
  created_at = ''
  updated_at = ''
}

export default class PaymentMethod extends PaymentMethodDTO {
  static api = PaymentMethodsApi

  constructor(DTO: PaymentMethodDTO) {
    super()
    Object.assign(this, DTO)
  }
}
